module.exports = __webpack_public_path__ + "static/media/webrtc.cbe7833f.svg";